import { sva } from '@agapi/ui/panda/css';

export const imageContentStyles = sva({
  slots: ['root', 'container', 'content', 'image', 'overlay'],
  base: {
    root: {
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
    },
    container: {
      display: 'flex',
      height: '100%',
      width: '100%',
      position: 'relative',
      justifyContent: 'center',
      alignItems: 'center'
    },
    content: {
      position: 'relative',
      zIndex: 2,
      gap: 3,
      display: 'flex',
      flexDirection: 'column',
      px: { base: '4', md: '6' },
      py: { base: '6', md: '8' }
    },
    image: {
      position: 'absolute',
      inset: '0',
      height: '100%',
      width: '100%',
      objectFit: 'cover'
    },
    overlay: {
      position: 'absolute',
      inset: '0',
      zIndex: 1,
      height: '100%',
      width: '100%'
    }
  },
  variants: {
    imagePosition: {
      none: {
        image: { display: 'none' },
        overlay: { display: 'none' }
      },
      background: {},
      left: {
        container: {
          flexDirection: { base: 'column', md: 'row' }
        },
        content: { flex: '0 0 50%' },
        image: {
          mt: {base: 4, md: 8},
          mb: 'auto',
          position: { md: 'relative' },
          flex: { md: '0 0 50%' },
          borderRadius: 'image.content'
        },
        overlay: {
          position: { md: 'absolute' },
          left: { md: '50%' },
          width: { md: '50%' }
        }
      },
      right: {
        container: {
          flexDirection: { base: 'column', md: 'row-reverse' }
        },
        content: { flex: '0 0 50%' },
        image: {
          mt: {base: 4, md: 8},
          mb: 'auto',
          position: { md: 'relative' },
          flex: { md: '0 0 50%' },
          borderRadius: 'image.content'
        },
        overlay: {
          position: { md: 'absolute' },
          right: { md: '50%' },
          width: { md: '50%' }
        }
      }
    },
    contentAlign: {
      start: {
        content: {
          justifyContent: 'flex-start',
          alignItems: 'flex-start'
        }
      },
      center: {
        container: {
          position: 'static'
        },
        content: {
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center'
        }
      },
      end: {
        content: {
          justifyContent: 'flex-end',
          alignItems: 'flex-end'
        }
      }
    },
    overlay: {
      dark: {
        overlay: {
          display: 'block',
          background: 'rgba(0, 0, 0, 0.2)'
        }
      },
      light: {
        overlay: {
          display: 'block',
          background: 'rgba(255, 255, 255, 0.2)'
        }
      }
    }
  },
});